import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/team")({
  // Component moved to $orgSlug.admin.team.lazy.tsx for code splitting
});
